<template>
    <Teleport to="body">
        <Transition name="load-scale">
            <div
                v-if="open"
                class="fixed inset-0 z-[9999] flex h-[100vh] w-[100vw] items-center justify-center bg-white/50 backdrop-blur-sm dark:bg-[#0a0a0a]/50"
            >
                <ProgressSpinner
                    :pt="{
                        circle: {
                            class: '!stroke-primary dark:!stroke-secondary',
                        },
                    }"
                    style="width: 70px; height: 70px"
                    strokeWidth="4"
                    animationDuration=".8s"
                />
            </div>
        </Transition>
    </Teleport>
</template>

<script>
    import LoadingEventtBus from './LoadingEventtBus';
    export default {
        name: 'ModalLoading',
        data() {
            return {
                open: false,
            };
        },
        methods: {
            openLoading() {
                this.open = true;
            },
            closeLoading() {
                this.open = false;
            },
        },
        mounted() {
            LoadingEventtBus.on('open', this.openLoading);
            LoadingEventtBus.on('close', this.closeLoading);
        },
        beforeUnmount() {
            LoadingEventtBus.off('open', this.openLoading);
            LoadingEventtBus.off('close', this.closeLoading);
        },
    };
</script>

<style lang="scss" scoped>
    .load-scale-enter-active,
    .load-scale-leave-active {
        transition:
            opacity 0.18s ease,
            transform 0.18s ease;
    }

    .load-scale-enter-from,
    .load-scale-leave-to {
        opacity: 0;
        transform: scale(0.98);
    }
</style>
